import { APICore } from "./apiCore";

const api = new APICore();

function fetchEnquiry(params: { filter: any, page: string, limit: string, sortBy: string, sort: string, filterBy?: any, searchBy?: string }) {
  const baseUrl = `/enquiry?page=${params.page}&limit=${params.limit}&sortBy=${params.sortBy}&sort=${params.sort}&userId=${params.filter.user_id}&userType=${params.filter.type}&filterBy=${params.filterBy}&searchBy=${params.searchBy ? params.searchBy : ''}`;
  return api.get(`${baseUrl}`, "");
}

function fetchEnquiryForDasbord(params: { filterBy?: any, filter?: any }) {
  const baseUrl = `/enquiry/dashboard/data?filterBy=${params.filterBy}&filter=${params.filter}`;
  return api.get(`${baseUrl}`, "");
}



function fetchSingleEnquiry(id: any) {
  const baseUrl = `/enquiry/${id}`;
  return api.get(`${baseUrl}`, id);
}

function createEnquiry(body: any) {
  const baseUrl = "/enquiry";
  return api.create(`${baseUrl}`, body);
}

function createEnquiryForm(enquiryForm: any) {
  const baseUrl = "/enquiry/form";
  return api.create(`${baseUrl}`, enquiryForm);
}
function getEnquiryForm(enquiryForm: any) {
  const baseUrl = `/enquiry/form`
  return api.get(`${baseUrl}`, enquiryForm);
}

function updateEnquiry(body: any) {
  const baseUrl = `/enquiry/${body.id}`;
  return api.update(`${baseUrl}`, body);
}

function fetchEnquiryStatus() {
  const baseUrl = `/enquiry/status`;
  return api.get(`${baseUrl}`, {});
}

function fetchRevenueChartData(params: { filterBy?: any, filter?: any }) {
  const baseUrl = `/enquiry/revenue/data?filterBy=${params.filterBy}&filter=${params.filter}`
  return api.get(`${baseUrl}`, "");
}


export { fetchEnquiry, fetchSingleEnquiry, createEnquiry, updateEnquiry, createEnquiryForm, fetchEnquiryStatus, getEnquiryForm, fetchRevenueChartData, fetchEnquiryForDasbord };
